import React, { useEffect, useMemo, useState } from "react";
import { useUser } from "../../hooks";
import { readPlatformSupportSessionMeta } from "../../utils/platformSupportSession";

export default function SupportSessionBanner() {
  const user = useUser();
  const [now, setNow] = useState(() => Date.now());

  const meta = useMemo(() => readPlatformSupportSessionMeta(user), [user]);

  useEffect(() => {
    if (!meta?.expires_at) return undefined;
    const id = window.setInterval(() => setNow(Date.now()), 15000);
    return () => window.clearInterval(id);
  }, [meta?.expires_at]);

  if (!meta?.expires_at && !user?.is_platform_support) {
    return null;
  }

  const expiresMs = meta?.expires_at ? new Date(meta.expires_at).getTime() : NaN;
  const remainingMs = Number.isFinite(expiresMs) ? expiresMs - now : 0;
  const expired = Number.isFinite(expiresMs) && remainingMs <= 0;
  const mins = Math.max(0, Math.ceil(remainingMs / 60000));
  const displayName =
    meta?.display_name ||
    user?.name ||
    (meta?.admin_name
      ? `Platform Support (${meta.admin_name})`
      : "Platform Support");

  return (
    <div
      className="px-3 py-2 text-white"
      style={{
        background: expired
          ? "linear-gradient(90deg, #d40000 0%, #8b313a 100%)"
          : "linear-gradient(90deg, #31778c 0%, #255a6b 100%)",
        fontSize: 13,
      }}
      role="status"
    >
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
        <span className="fw-semibold">
          {displayName}
          {meta?.company_name ? ` · ${meta.company_name}` : ""}
        </span>
        <span>
          {expired
            ? "Session expired — request a new support session from Manager."
            : `Full-write support session · ends in ~${mins} min`}
        </span>
      </div>
    </div>
  );
}
